import * as React from "react"
import { cn } from "./lib/cn"

function GlassSecondaryButton({ className, ...props }: React.ComponentProps<"button">) {
  return (
    <button
      data-slot="glass-secondary-button"
      className={cn(
        "inline-flex items-center gap-1.5",
        "rounded-full px-4 py-1.5 text-sm",
        "bg-gray-500/5 backdrop-blur-xs border border-gray-500/10 text-gray-500",
        "hover:bg-gray-500/10 active:scale-[0.97] transition-all",
        "disabled:opacity-50 disabled:pointer-events-none",
        // Dark mode
        "dark:bg-white/8 dark:border-white/10 dark:text-gray-400",
        "dark:hover:bg-white/12",
        className
      )}
      {...props}
    />
  )
}

export { GlassSecondaryButton }
